export default __webpack_public_path__ + "static/media/travelguide@2x.bcb61d91.png";